import React from 'react';
import { Tree, Dropdown } from 'antd';
import { DeleteOutlined, EditOutlined, MoreOutlined, PlusOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { MODAL_TYPES } from 'admin/constants';

const TreeNode = ({ id, title, onDrop, seeMoreButton, getId, ...props }) => {
  return (
    <NodeContainer {...props}>
      <TitleContainer>{title}</TitleContainer>
      {seeMoreButton}
    </NodeContainer>
  );
};

const TitleContainer = styled.div`
  max-width: 100%;
  text-overflow: ellipsis;
  overflow-x: hidden;
`;

const NodeContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: ${props => props.theme.colors.secondary};
  padding: 5px;
`;

const GroupTree = ({
  treeData,
  showModal,
  onTreeNodeFocus,
  onTreeNodeSelect,
  selectedTreeNode,
  addObjectsToGroup,
  defaultTreeNode,
  getObjectId = object => object.id,
  checkable = false,
  onCheck,
  checkedKeys,
}) => {
  const handleMenuSelect = (key, treeNode, showModal, onTreeNodeFocus) => {
    onTreeNodeFocus({ ...treeNode });
    showModal(key);
  };

   const renderSeeMoreItem = [
    {
      key: MODAL_TYPES.ADD,
      label: "Add",
      icon: <PlusOutlined />,
    },
    {
      key: MODAL_TYPES.EDIT,
      label: "Edit",
      icon: <EditOutlined />,
    },
    {
      key: MODAL_TYPES.DELETE,
      label: "Delete",
      icon: <DeleteOutlined />,
      danger: true,
    },
  ];

  const renderSeeMoreButton = (treeNode, showModal, setFocusedTreeNode) => (
    <Dropdown
      trigger={['click']}
      onClick={e => e.stopPropagation()}
      menu={{
        items: renderSeeMoreItem,
        onClick: ({ key }) => handleMenuSelect(key, treeNode, showModal, setFocusedTreeNode),
      }}
      overlayClassName='group-menu'
    >
      <MoreOutlined />
    </Dropdown>
  );

  const renderTreeNode = treeNode => {
    if (treeNode.id === defaultTreeNode.id) {
      return (
        <TreeNode
          id={treeNode.id}
          title={treeNode.title}
          onDrop={addObjectsToGroup}
          seeMoreButton={null}
          getId={getObjectId}
        />
      );
    }
    return (
      <Dropdown
        trigger={['contextMenu']}
        menu={{
          items: renderSeeMoreItem,
          onClick: ({ key }) => handleMenuSelect(key, treeNode, showModal, onTreeNodeFocus),
        }}
        overlayClassName='group-menu'
      >
        <TreeNode
          id={treeNode.id}
          title={treeNode.title}
          onDrop={addObjectsToGroup}
          seeMoreButton={renderSeeMoreButton(treeNode, showModal, onTreeNodeFocus)}
          getId={getObjectId}
        />
      </Dropdown>
    );
  };

  const getTree = () => {
    return (
      <Tree
        onClick={e => e.preventDefault}
        blockNode
        treeData={treeData}
        selectedKeys={[selectedTreeNode.key]}
        titleRender={renderTreeNode}
        onSelect={(_, { node }) => (selectedTreeNode.id !== node.id ? onTreeNodeSelect(node) : null)}
        checkable={checkable}
        onCheck={onCheck}
        checkedKeys={checkedKeys}
        style={{backgroundColor:  '#212121' }}
      />
    );
  };
  return <div style={{ width: '100%' }}>{getTree()}</div>;
};

export default GroupTree;
